import ReviewCard from "./UI/ReviewCard";

export default ReviewCard;